import httpClient from '../../../global/httpClient';
import * as apis from '../../../constants/api';

export const getTrailCourse = courseId => httpClient.get(`${apis.GET_TRAIL_COURSE}/${courseId}`);
export const addToFavoriteList = payload =>
  httpClient.post(apis.POST_VIDEOS_COLLECT, { ...payload }, { ignore: true });
